<div class="flex flex-column lg:flex-row justify-content-between">
  <div class="flex flex-row lg:flex-column">
    <div class="mr-2 text-500">Description:</div>
    <div>
      <span class="text-gray-900 white-space-nowrap">
        {{ data.job_description }}
      </span>
    </div>
  </div>
  <div class="flex flex-row">
    <div class="flex flex-column">
      <div class="mr-2 text-500">Job Number:</div>
      <div>
        <span class="text-gray-900 white-space-nowrap">
          {{ data.job_no }}
        </span>
      </div>
    </div>
  </div>
  <div class="flex flex-row">
    <div class="flex flex-column">
      <div class="mr-2 text-500">Job Type:</div>
      <div>
        <span class="text-gray-900 white-space-nowrap">
          {{ data.job_type }}
        </span>
      </div>
    </div>
  </div>
  <div class="flex flex-row">
    <div class="flex flex-column">
      <div class="mr-2 text-500">Job Remarks:</div>
      <div>
        <span class="text-gray-900 white-space-nowrap">
          {{ data.remark }}
        </span>
      </div>
    </div>
  </div>
</div>
